export const NAV = [
  { label: "About", to: "/about" },
  { label: "Concierge Process", to: "/process" },
  { label: "Services", to: "/services" },
  { label: "Specialties", to: "/specialties" },
  { label: "Membership", to: "/membership" },
  { label: "Contact", to: "/contact" },
];

export const TRUST_METRICS = [
  { label: "Partner Hospitals", value: "40+" },
  { label: "Specialists Network", value: "500+" },
  { label: "Countries Served", value: "22" },
  { label: "Dedicated Case Managers", value: "24" },
  { label: "Concierge Assistance", value: "24 × 7" },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Share Your Medical Reports",
    body: "Securely share existing reports and history. A dedicated concierge is assigned within twenty-four hours.",
  },
  {
    n: "02",
    title: "Receive a Personalised Care Plan",
    body: "Your concierge curates specialist opinions, hospital recommendations, and estimated timelines — privately.",
  },
  {
    n: "03",
    title: "Connect With Leading Specialists",
    body: "Priority appointments and virtual consultations with India's most sought-after doctors.",
  },
  {
    n: "04",
    title: "Travel With Confidence",
    body: "Visas, flights, private transfers, hotel or serviced apartments, translators — quietly arranged.",
  },
  {
    n: "05",
    title: "Recover With Ongoing Support",
    body: "Post-procedure coordination, follow-up video reviews, and continuity of care in your home country.",
  },
];

export const SERVICES = [
  { title: "Medical Concierge", body: "One dedicated coordinator across your entire journey." },
  { title: "Hospital Matching", body: "Vetted institutions matched to condition, budget and comfort." },
  { title: "Specialist Matching", body: "Introductions to India's most respected consultants." },
  { title: "Medical Second Opinions", body: "Confidential review by senior specialists within 48 hours." },
  { title: "Fast-track Appointments", body: "Priority scheduling — often within days, not months." },
  { title: "Surgery Coordination", body: "Pre-op, admission, and OT logistics handled end-to-end." },
  { title: "Travel Assistance", body: "Visa letters, flights, ground transfers, family stays." },
  { title: "Recovery Planning", body: "Structured follow-up and rehabilitation at home." },
];

export const SPECIALTIES = [
  {
    key: "cardiology",
    name: "Cardiology",
    tagline: "Interventional and structural heart care.",
    body: "From coronary angioplasty to advanced valve procedures and complex bypass surgery — arranged with the country's most awarded cardiac teams.",
  },
  {
    key: "orthopedics",
    name: "Orthopedics",
    tagline: "Joint replacement and spine.",
    body: "Robotic knee and hip replacements, sports injury reconstruction, and minimally invasive spine procedures with fast return to mobility.",
  },
  {
    key: "ivf",
    name: "IVF & Fertility",
    tagline: "Discreet, world-class reproductive medicine.",
    body: "IVF, ICSI, egg donation and gestational surrogacy programmes managed with privacy, dignity and compassionate case management.",
  },
  {
    key: "cosmetic",
    name: "Cosmetic Surgery",
    tagline: "Aesthetic and reconstructive.",
    body: "Facial aesthetics, body contouring, hair restoration and reconstructive procedures with senior board-certified surgeons.",
  },
];

export const MEMBERSHIP_INTRO = "Choose the level of concierge support that's right for your healthcare journey.";

export const MEMBERSHIP = [
  {
    tier: "Silver",
    category: "Medical Expert Opinion",
    positioning: "Get the right medical advice.",
    description: "Perfect for patients seeking clarity before making an important medical decision.",
    features: [
      "Dedicated Case Coordinator",
      "Medical Report Review",
      "Doctor Consultation Coordination",
      "One Expert Second Opinion",
    ],
    cta: "Request Consultation",
  },
  {
    tier: "Gold",
    category: "Treatment Coordination",
    positioning: "Get your treatment planned and coordinated.",
    description: "Everything in Silver, plus complete treatment planning and hospital coordination.",
    featured: true,
    features: [
      "Everything in Silver",
      "Hospital & Specialist Matching",
      "Priority Appointment Scheduling",
      "Personalised Treatment Plan",
      "Cost Estimate Coordination",
      "Dedicated Concierge Support",
      "Hospital Admission & Surgery Coordination",
    ],
    cta: "Request Private Consultation",
  },
  {
    tier: "Platinum",
    category: "Executive Medical Concierge",
    positioning: "Have your entire healthcare journey managed.",
    description: "Everything in Gold, with complete white-glove concierge management from arrival to recovery.",
    features: [
      "Everything in Gold",
      "Travel & Accommodation Coordination",
      "Airport Pickup & Local Transfers",
      "Dedicated Family Liaison",
      "In-Hospital Concierge Support",
      "Post-Treatment Follow-up (90 Days)",
    ],
    cta: "Speak With Our Concierge",
  },
];

export const COUNTRIES = ["United States", "Canada", "United Kingdom", "United Arab Emirates", "Australia", "Saudi Arabia", "Singapore", "Kenya", "Nigeria", "Other"];

export const SPECIALTY_OPTIONS = ["Cardiology", "Orthopedics", "IVF & Fertility", "Cosmetic Surgery", "Not sure — please advise"];
